export default __webpack_public_path__ + "static/media/9.eb28627c.jpg";